/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.onImageLoad = this.finishLoading.bind(this);
    this.sourceObserver = new MutationObserver(() => this.handleLazy());
  }

  connectedCallback() {
    this.wrapper = this.closest('.media-wrapper');
    if (!this.wrapper) return;
    this.addEventListener('load', this.onImageLoad);
    this.addEventListener('error', this.onImageLoad);
    this.sourceObserver.observe(this, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
    this.handleLazy();
  }

  disconnectedCallback() {
    this.sourceObserver.disconnect();
    this.removeEventListener('load', this.onImageLoad);
    this.removeEventListener('error', this.onImageLoad);
  }

  finishLoading() {
    if (!this.wrapper) return;
    this.classList.toggle('loaded', this.naturalWidth > 0);
    this.wrapper.classList.remove('loading');
  }

  handleLazy() {
    if (this.complete) {
      this.finishLoading();
      return;
    }
    this.classList.remove('loaded');
    this.wrapper.classList.add('loading');
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });
